import cn from 'classnames'
import React from 'react'

import styles from './PrimaryButton.module.scss'

export const PrimaryButton: React.FC<
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
> = ({ children, className, ...props }) => {
  return (
    <button {...props} className={cn(className, styles.primaryButton)}>
      {children}
    </button>
  )
}
